import { render, staticRenderFns } from "./ConsentDetailUser.vue?vue&type=template&id=0a230834&scoped=true&"
import script from "./ConsentDetailUser.vue?vue&type=script&lang=js&"
export * from "./ConsentDetailUser.vue?vue&type=script&lang=js&"
import style0 from "./ConsentDetailUser.vue?vue&type=style&index=0&id=0a230834&prod&lang=css&"
import style1 from "./ConsentDetailUser.vue?vue&type=style&index=1&id=0a230834&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a230834",
  null
  
)

export default component.exports